import InfoIcon from "@material-ui/icons/Info";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { IRoute } from "src/common/typings/routes";
import { Commercial } from "./Commercial";
import { PaymentsList } from "./pages/PaymentsList";
import { TerminalCharges } from "./pages/TerminalCharges/TerminalCharges";

export const CommercialRoute: IRoute = {
  title: "Commercial",
  path: "/commercial",
  icon: LocalOfferIcon,
  component: Commercial,
  guard: true,
  subRoutes: [
    {
      icon: InfoIcon,
      component: TerminalCharges,
      path: "/terminal-charges",
      title: "Terminal Charges",
    },
    {
      icon: InfoIcon,
      component: PaymentsList,
      path: "/payments-list",
      title: "List of Payments",
    },
  ],
};
